// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layersWrapper {
  position: absolute;
  bottom: 16px;
  left: 16px;
  width: 224px;
  background-color: white;
  border-radius: 8px;
  border-color: white;
  z-index: 18;
}
.layersWrapper .layersTitle {
  font-size: 16px;
  font-weight: 500;
  height: 40px;
  padding: 7px 15px;
  cursor: pointer;
}
.layersWrapper .checkBoxWrapper .divider {
  border: none;
  height: 1px;
  margin: 0;
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.12);
}
.layersWrapper .checkBoxWrapper .checkBoxPanel {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  padding: 8px 16px;
}
.layersWrapper .checkBoxWrapper .checkBoxPanel .checkboxItem {
  height: 32px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  margin-right: 16px;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
}
.layersWrapper .checkBoxWrapper .checkBoxPanel .checkboxItem .ant-checkbox-wrapper {
  width: 100%;
}
.layersWrapper .checkBoxWrapper .checkBoxPanel .checkboxItem .ant-checkbox-wrapper > span {
  color: black;
}
.layersWrapper .checkBoxWrapper .doneBtn {
  margin: 8px 16px 24px 16px;
  width: 192px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  padding: 5px 15px;
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
  min-width: 64px;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-weight: 500;
  line-height: 1.75;
  border-radius: 8px;
  text-transform: uppercase;
  background-color: white;
  cursor: pointer;
  transition: 0.3s;
}
.layersWrapper .checkBoxWrapper .doneBtn:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.layersWrapper .checkBoxWrapper .doneBtn span {
  color: black;
}
.layerPopover .ant-popover-content {
  top: 30px;
  left: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/Layers/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AACF;AATA;EAWI,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AACJ;AAhBA;EAoBM,YAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,qCAAA;AADN;AAvBA;EA4BM,aAAA;EACA,eAAA;EACA,sBAAA;EACA,iBAAA;AAFN;AA7BA;EAkCQ,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wCAAA;AAFR;AAtCA;EA2CU,WAAA;AAFV;AAGU;EAEE,YAAA;AAFZ;AA5CA;EAqDM,0BAAA;EACA,YAAA;EACA,qCAAA;EACA,iBAAA;EACA,0BAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,qKAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,yBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAPN;AASM;EACE,qCAAA;AAPR;AAjEA;EA6EQ,YAAA;AATR;AAgBA;EAEI,SAAA;EACA,UAAA;AAfJ","sourcesContent":[".layersWrapper {\n  position: absolute;\n  bottom: 16px;\n  left: 16px;\n  width: 224px;\n  background-color: white;\n  border-radius: 8px;\n  border-color: white;\n  z-index: 18;\n\n  .layersTitle {\n    font-size: 16px;\n    font-weight: 500;\n    height: 40px;\n    padding: 7px 15px;\n    cursor: pointer;\n  }\n\n  .checkBoxWrapper {\n    .divider {\n      border: none;\n      height: 1px;\n      margin: 0;\n      flex-shrink: 0;\n      background-color: rgba(0, 0, 0, 0.12);\n    }\n\n    .checkBoxPanel {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: column;\n      padding: 8px 16px;\n\n      .checkboxItem {\n        height: 32px;\n        cursor: pointer;\n        display: inline-flex;\n        align-items: center;\n        margin-right: 16px;\n        vertical-align: middle;\n        -webkit-tap-highlight-color: transparent;\n\n        .ant-checkbox-wrapper {\n          width: 100%;\n          & > span {\n            //font-weight: bold;\n            color: black;\n          }\n        }\n      }\n    }\n\n    .doneBtn {\n      margin: 8px 16px 24px 16px;\n      width: 192px;\n      border: 1px solid rgba(0, 0, 0, 0.23);\n      padding: 5px 15px;\n      color: rgba(0, 0, 0, 0.87);\n      font-size: 16px;\n      min-width: 64px;\n      box-sizing: border-box;\n      transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n      font-weight: 500;\n      line-height: 1.75;\n      border-radius: 8px;\n      //letter-spacing: 2px;\n      text-transform: uppercase;\n      background-color: white;\n      cursor: pointer;\n      transition: .3s;\n\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.04)\n      }\n\n      span {\n        //font-weight: bold;\n        color: black;\n      }\n    }\n  }\n}\n\n\n.layerPopover {\n  .ant-popover-content {\n    top: 30px;\n    left: 20px;\n  }\n\n}\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
